module.exports = __webpack_public_path__ + "video/1000_KMSAT15_2022_Conclusion.25b0055a.vtt";